module.exports = __webpack_public_path__ + "assets/img/e27bfb8e89547b16e7c54a37211e394b.png";